import { LocalBar } from '@mui/icons-material'
import DrinkList from './DrinkList'
import DrinEdit from './DrinkEdit'
import DrinCreate from './DrinkCreate'

const drinkIndex = {
  icon: LocalBar,
  list: DrinkList,
  edit: DrinEdit,
  create: DrinCreate,
}

export default drinkIndex
